import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import Modal from '@justgiving/modal';
import ProfileImage from '../../components/ProfileImage/ProfileImage';
import UploadProfileImage from '../../components/UploadProfileImage/UploadProfileImage';
import { paths } from '../../constants';
import { track } from '../../utils/koala-analytics';
import { useTranslation } from 'react-i18next';

interface NameProps {
  title: string;
  first: string;
  last: string;
  profilePictureUrl: string;
}

const trackEditPhoto = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > photo',
    event_value: 'edit',
  };
  track(trackingData);
};

const trackEditName = () => {
  const trackingData = {
    event: 'link click',
    subtype: 'hyperlink',
    page_section: 'personal details > name',
    event_value: 'edit',
  };
  track(trackingData);
};

const Name: React.FC<NameProps> = ({
  title,
  first,
  last,
  profilePictureUrl,
}) => {
  const { t } = useTranslation();
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);

  return (
    <section className="details-block name">
      <div className="jg-space-phsm@sm jg-space-phn@lg">
        <div className="name__avatar jg-icon--profile">
          <ProfileImage
            imageUrl={profilePictureUrl}
            rounded
            objectFit="cover"
          />
          <br />
          <button
            onClick={() => {
              trackEditPhoto();
              setShowImageUploadModal(true);
            }}
            className="jg-text--link qa-link__profile-image"
          >
            {t('personalDetails.edit')}
          </button>
          <Modal
            isOpen={showImageUploadModal}
            onRequestClose={() => setShowImageUploadModal(false)}
            preventScroll={true}
          >
            <UploadProfileImage
              onImageUploaded={() => setShowImageUploadModal(false)}
              onImageRemoved={() => setShowImageUploadModal(false)}
              currentImageUrl={profilePictureUrl}
            />
          </Modal>
        </div>
        <div className="name__details jg-space-mtsm">
          <p className="jg-text--medium-regular">{t('personalDetails.name')}</p>
          <p>
            <span className="data-value">
              {title === 'Other' ? '' : title} {first} {last}
            </span>
            <Link
              to={paths.Name}
              onClick={trackEditName}
              className="jg-edit-link qa-link__name-and-title jg-space-mlsm"
            >
              {t('personalDetails.edit')}
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Name;
